export const DANCE_PLAY_MODES = ["live", "video"];

/** Missing or empty means both, matching tracks saved before the field existed. */
export const normalizeDancePlayModes = (value) => {
  const raw = Array.isArray(value) ? value : [];
  const modes = DANCE_PLAY_MODES.filter((mode) => raw.includes(mode));
  return modes.length ? modes : ["live", "video"];
};

/**
 * Admin-facing track format.
 * - video_only: recorded videos only. The Dance Live schedule never applies.
 * - live: recorded videos at any time, and a live battle while a window is open.
 * - live_only: live battles only, and only while a window is open. Ranked.
 */
export const DANCE_FORMATS = {
  VIDEO_ONLY: "video_only",
  LIVE: "live",
  LIVE_ONLY: "live_only",
};

export const danceFormatFromPlayModes = (playModes) => {
  const modes = normalizeDancePlayModes(playModes);
  const live = modes.includes("live");
  const video = modes.includes("video");
  if (live && !video) return DANCE_FORMATS.LIVE_ONLY;
  if (!live && video) return DANCE_FORMATS.VIDEO_ONLY;
  return DANCE_FORMATS.LIVE;
};

export const playModesFromDanceFormat = (format) => {
  if (format === DANCE_FORMATS.VIDEO_ONLY) return ["video"];
  if (format === DANCE_FORMATS.LIVE_ONLY) return ["live"];
  return ["live", "video"];
};

export const danceFormatLabel = (format) => {
  if (format === DANCE_FORMATS.VIDEO_ONLY) return "Video only";
  if (format === DANCE_FORMATS.LIVE_ONLY) return "Live only";
  return "Live and video";
};
